import React from 'react';
import { useAdminConfig } from '../../hooks/useAdminConfig';
import { Card } from '../../components/ui/Card';
import { GeneralSettingsForm } from '../../components/admin/GeneralSettingsForm';
import { LoadingSpinner } from '../../components/ui/Feedback';
import { Settings2 } from 'lucide-react';

export const SystemSettingsPage: React.FC = () => {
  const { generalSettings, isLoading, updateGeneralSetting } = useAdminConfig();

  if (isLoading) return <LoadingSpinner size="lg" text="Loading System Settings..." />;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-slate-100 flex items-center gap-2">
          <Settings2 className="w-5 h-5 text-sky-400" />
          General Settings
        </h3>
        <p className="text-xs text-slate-400">Configure application-wide system settings</p>
      </div>

      <Card title="System Configuration">
        <GeneralSettingsForm
          settings={generalSettings}
          onUpdate={updateGeneralSetting}
        />
      </Card>
    </div>
  );
};
